import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Link from '~/components/ui/Link'
import { isReCaptchaV3Enabled } from '~/features/ReCaptcha/utils'

const ReCaptchaV3Terms = ({ textSize }) => (isReCaptchaV3Enabled ? (
  <div className="pt-2">
    <p className={classNames(textSize, 'text-center text-black')}>
      This site is protected by reCAPTCHA and the Google
      {' '}
      <Link
        to="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
        className={textSize}
        size=""
      >
        Privacy Policy
      </Link>
      {' '}
      and
      {' '}
      <Link
        to="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
        className={textSize}
        size=""
      >
        Terms of Service
      </Link>
      {' '}
      apply.
    </p>
  </div>
) : null)

ReCaptchaV3Terms.propTypes = {
  textSize: PropTypes.string,

}

ReCaptchaV3Terms.defaultProps = {
  textSize: 'text-xs',
}

export default ReCaptchaV3Terms
